// import { useNavigate } from "react-router-dom";
import ShmupCardStyled from "./ShmupCardStyled";

const ShmupCard = ({
  shmup: { name, imgSquareJP, imgSquareEU, screen, tate, numPlayers, id },
}) => {
  // const navigate = useNavigate;

  const shmupDetail = () => {
    console.log(`Shmup ${name}`);
    // navigate(`/shmup-detail/${id}`);
  };

  return (
    <ShmupCardStyled onClick={shmupDetail}>
      <img
        className="image"
        alt={`${name} art game`}
        src={imgSquareJP !== "" ? `${imgSquareJP}` : `${imgSquareEU}`}
      />

      <span className="text">{name}</span>

      <div className="details">
        <div>{screen}</div>
        <div>Tate {tate ? `✔️` : `✖️`}</div>
        <div>
          <div className="numPlayers">
            <span className="playersNumber">{numPlayers}</span>
            <span className="playersText">Player(s)</span>
          </div>
        </div>
      </div>
    </ShmupCardStyled>
  );
};

export default ShmupCard;
